export const dashboardState = {
  totalData: [],
  totalOrders: [],
  uploadSliderBtn: true,
  imageUpload: false,
  financeOrders: [],
  sliderImages: [],
};

export const dashboardReducer = (state, action) => {
  
  switch (action.type) {
    case "totalData":
      return {
        ...state,
        totalData: action.payload,
      };
    case "totalOrders":
      return {
        ...state,
        totalOrders: action.payload,
      };
    case "uploadSliderBtn":
      return {
        ...state,
        uploadSliderBtn: action.payload,
      };
    case "imageUpload":
      return {
        ...state,
        imageUpload: action.payload,
      };
    case "sliderImages":
      return {
        ...state,
        sliderImages: action.payload,
      };
      case "financeOrders":
        return {
          ...state,
          financeOrders: action.payload, // financeOrders est maintenant un tableau direct
          loading: false,
        };

    default:
      return state;
  }
};
